/* eslint-disable @angular-eslint/no-output-native */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  standalone: false,
  selector: 'lib-cm-slide-toggle',
  templateUrl: './cm-slide-toggle.component.html',
  styleUrls: ['./cm-slide-toggle.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CmSlideToggleComponent),
      multi: true,
    },
  ],
})
export class CmSlideToggleComponent implements ControlValueAccessor {
  @Input() disabled = false;
  @Input() checked = false;

  writeValue(value: boolean): void {
    this.checked = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  toggleChanged(event: MatSlideToggleChange): void {
    this.checked = event.checked;
    this.onChange(this.checked);
    this.onTouched();
  }

  private onChange = (value: boolean) => {};

  private onTouched = () => {};
}
